// phonics_data_lt11.js
// Letter Teams L11 - L11 Long Vowel Sounds Y as a Vowel
// 路由：/phonics/lt11

const MEDIA_BASE = '/media/phonics/lt11';
const V = 'v1';

export const letterDataLt11 = {
  id: 'lt11',
  letter: 'L11',
  title: 'L11 Long Vowel Sounds Y as a Vowel',
  mediaBase: MEDIA_BASE,

  // P1: Watch the video (Part 1) → part1.mp4
  part1Video: {
    src: `${MEDIA_BASE}/part1.mp4?${V}`,
  },

  // P2: Repeat the words (Part 3) → part3.mp4
  part3Video: {
    src: `${MEDIA_BASE}/part3.mp4?${V}`,
  },

  // P3: Say the words（静态图片复习）→ review.png
  reviewPic: {
    src: `${MEDIA_BASE}/review.png?${V}`,
  },

  // P7/P8/P9: 三段故事（只有英文台词，无中文）
  storySections: [
    {
      label: 'Learn the story (1)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story1.mp4?${V}` }],
      lines: [
        { en: "The sun is out.", audioEn: `${MEDIA_BASE}/story1_1.mp3?${V}` },
        { en: "The sky is blue.", audioEn: `${MEDIA_BASE}/story1_2.mp3?${V}` },
        { en: "Let's have fun here!", audioEn: `${MEDIA_BASE}/story1_3.mp3?${V}` },
        { en: "Green sees a pony.", audioEn: `${MEDIA_BASE}/story1_4.mp3?${V}` },
        { en: "Let me ride the pony!", audioEn: `${MEDIA_BASE}/story1_5.mp3?${V}` },
        { en: "You cannot try.", audioEn: `${MEDIA_BASE}/story1_6.mp3?${V}` },
        { en: "You are too tiny.", audioEn: `${MEDIA_BASE}/story1_7.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (2)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story2.mp4?${V}` }],
      lines: [
        { en: "Do not cry.", audioEn: `${MEDIA_BASE}/story2_1.mp3?${V}` },
        { en: "The pals go by games.", audioEn: `${MEDIA_BASE}/story2_2.mp3?${V}` },
        { en: "Red sees a teddy.", audioEn: `${MEDIA_BASE}/story2_3.mp3?${V}` },
        { en: "I want a teddy!", audioEn: `${MEDIA_BASE}/story2_4.mp3?${V}` },
        { en: "Let me try!", audioEn: `${MEDIA_BASE}/story2_5.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (3)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story3.mp4?${V}` }],
      lines: [
        { en: "The game is not easy.", audioEn: `${MEDIA_BASE}/story3_1.mp3?${V}` },
        { en: "Look at the sky.", audioEn: `${MEDIA_BASE}/story3_2.mp3?${V}` },
        { en: "It is night!", audioEn: `${MEDIA_BASE}/story3_3.mp3?${V}` },
        { en: "Let's go home.", audioEn: `${MEDIA_BASE}/story3_4.mp3?${V}` },
        { en: "Do not cry, Red.", audioEn: `${MEDIA_BASE}/story3_5.mp3?${V}` },
        { en: "Here is a teddy for you!", audioEn: `${MEDIA_BASE}/story3_6.mp3?${V}` },
        { en: "Yay!", audioEn: `${MEDIA_BASE}/story3_7.mp3?${V}` },
      ],
    },
  ],
};
